// extracted by mini-css-extract-plugin
module.exports = {"contentTooltip":"tooltip_contentTooltip__4PC5P","default":"tooltip_default__7qb8R","left":"tooltip_left__f7_VK","right":"tooltip_right__auXfo","tooltip":"tooltip_tooltip__gYdtn"};